import {request} from "../../../utils/apiUtils";
import {URL_API} from "../../../url.config";

let CLBController = {

    create: (payload, callback) => {
        return request({
            url: `${URL_API}/api/sas-school/clb/create`,
            method: 'POST',
            body: {
                ...payload,
            },
        }, callback)
    },
    edit: (payload, callback) => {
        return request({
            url: `${URL_API}/api/sas-school/clb/edit`,
            method: 'POST',
            body: {
                ...payload,
            },
        }, callback)
    },
    detail: (clbId, callback) => {
        return request({
            url: `${URL_API}/api/sas-school/clb/detail/${clbId}`,
            method: 'GET',
        }, callback)
    },
    delete: (clbId, callback) => {
        return request({
            url: `${URL_API}/api/sas-school/clb/delete/${clbId}`,
            method: 'GET',
        }, callback)
    },
    list: (payload, callback) => {
        return request({
            url: `${URL_API}/api/sas-school/clb/list`,
            method: 'POST',
            body: {
                ...payload,
            },
        }, callback)
    }
}

export default CLBController